
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/local-partner",
      function () {
        return require("private-next-pages/resources/local-partner.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/local-partner"])
      });
    }
  